/* Credits
======================================== */
console.log('Sportivo: code by Carlos Mayo (https://carlosmayo.info/)');

/* Constants
======================================== */
const b = $('body');
const speed   = 200;
const speedx2 = 400;
const ease    = 'easeInOutQuint';
const isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

/* Device detection
======================================== */
isMobile ? b.addClass('mobile') : b.addClass('desktop');

/* Scroll Top
======================================== */
if('scrollRestoration' in history){
	history.scrollRestoration = 'manual';
	window.scrollTo(0,0);
}
// if(!b.hasClass('template-collection') &&
// 	!b.hasClass('template-collection-brand') &&
// 	!b.hasClass('template-list-collections') &&
// 	!b.hasClass('template-search')){
// 	if('scrollRestoration' in history){
// 		history.scrollRestoration = 'manual';
// 		window.scrollTo(0,0);
// 	}
// }

/* Global Functions
==================================== */
function heightViewport(){
	document.documentElement.style.cssText = `
		--h:  ${window.innerHeight}px;
		--hs: ${window.innerHeight - $('footer').outerHeight()}px;
	`;
}
if(isMobile){
	document.addEventListener('touchstart', () => {}, { passive: true });
	window.addEventListener('orientationchange', () => {
		setTimeout(heightViewport, 100); /* !!! alguna forma sin setTimeout? */
	});
}else{
	window.addEventListener('resize', heightViewport);
}
heightViewport();

/* Init
==================================== */
setTimeout(() => {
	$('#loader').fadeOut(speed*2, function(){
		$(this).addClass('completed');
	});
}, speed*2);

/* Lazy Loading
======================================== */
function checkLazy(target, observer){
	$(target).removeClass('lazy').addClass('lazyloaded');
	observer?.unobserve(target);
}

/* Observer: videos
======================================== */
let observeVideos;
const observerVideos = () => {
	observeVideos = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			const target = entry.target;
			if(entry.isIntersecting){
				target.play()
					.then(() => checkLazy(target))
					.catch(() => checkLazy(target, observeVideos));
			}else{
				if(!target.paused && !target.classList.contains('lazy')){ /* !!! revisar lo de la clase lazy */
					target.pause();
				}
			}
		});
	});
	document.querySelectorAll('video.lazy').forEach(video => {
		observeVideos.observe(video);
	});
}
document.querySelector('video.lazy') && observerVideos();

/* Observer: images
==================================== */
// let observeImages;
// const observerImages = () => {
// 	observeImages = new IntersectionObserver(entries => {
// 		entries.forEach(entry => {
// 			if(entry.isIntersecting){
// 				const target = entry.target;
// 				target.src = target.dataset.src;
// 				checkLazy(target, observeImages);
// 			}
// 		});
// 	});
// 	document.querySelectorAll('img.lazy').forEach(image => {
// 		observeImages.observe(image);
// 	});
// }
// document.querySelector('img.lazy') && observerImages();